define(["jquery", "@modules/tools/geocoder"], function ($, geocoder) {
    if ($("#seminarSearchCta").length > 0) {
        $("#seminarSearchCta").submit(function (e) {
            e.preventDefault();
            var zipOrAddress = $("#SeminarQuery").val().trim();
            $("#seminarSearchCta").find(":submit").attr("data-zipcode", zipOrAddress);
            if (zipOrAddress) {
                geocoder.geocode(zipOrAddress).then(function (coordinates) {
                    if (coordinates) {
                        $("#Latitude").val(coordinates.lat);
                        $("#Longitude").val(coordinates.lng);
                    }
                    $(e.target).unbind("submit").trigger("submit");
                });
            } else {
                $(e.target).unbind("submit").trigger("submit");
            }
        });

        $('a[data-bs-toggle="tab"]').on("shown.bs.tab", function (e) {
            var target = $(e.target).attr("href");
            if (target == "#county") {
                $("#SeminarType").val("Virtual");
            } else {
                $("#SeminarType").val("InPerson");
            }
        });
    }
});
